/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');

var isClient = (typeof window === "undefined" ? "undefined" : _rollupPluginBabelHelpers.typeof(window)) === 'object';

exports.default = isClient;
